import {
	// InfoCard,
	RecentActivityItem,
	ViewListCard
} from '../../components'
import { useUser } from '../../store/hooks'

export function HomePage() {
	const user = useUser()

	return (
		<>
			<section className="h-64 bg-gray-200">
				<div
					className="w-full py-6 md:w-1/4 xl:w-1/5 h-full flex flex-col items-center justify-around text-center"
					style={{ minWidth: '256px' }}
				>
					<h1>ADMIN DASHBOARD</h1>
					<img
						src={user.avatarUrl}
						className="w-16 h-16 rounded-full"
						alt="profile"
					/>
					{user.name ? (
						<span className="uppercase text-center">
							HELLO{`, ${user.name}`}
						</span>
					) : (
						<span className="animate-pulse space-x-4 space-y-4 h-6 w-24 bg-gray-300 rounded-sm" />
					)}
				</div>
			</section>
			<div className="flex flex-col-reverse md:flex-row">
				<section
					className="w-full md:w-1/4 xl:w-1/5 pt-4 pb-2 px-4"
					style={{ minWidth: '256px' }}
				>
					<h2 className="text-gray-300 text-sm">Updates</h2>
					{user.activities?.rows.map(({ _id: keyId, ...activity }) => (
						<RecentActivityItem key={keyId} item={activity} />
					))}
				</section>
				<div className="mt-0 md:-mt-52 w-full md:w-3/4 xl:w-4/5">
					<section className="flex flex-row flex-wrap items-center justify-center">
						{user.statistics?.map((statistic) => (
							<ViewListCard
								key={statistic.keyId}
								title={statistic.title}
								quantity={statistic.count}
								viewListPath={statistic.viewPath}
								createNewPath={statistic.createPath}
							/>
						))}
					</section>
					{/* <section className="flex flex-row flex-wrap items-center justify-center">
						<InfoCard title="Total Users" amount="1.2 K" />
						<InfoCard title="Exams Proceed" amount="25 K" />
						<InfoCard title="Quantified Candidates" amount="45%" />
					</section> */}
				</div>
			</div>
		</>
	)
}

export default HomePage
